import { AxiosResponse } from 'axios';
import { IBaseApiRequest } from '@api';
import { IPaginated, PaginationMeta, IBankEntity } from '@entities';
import { getSorterParamsForApi } from '@functions';

interface IGetAll extends IBaseApiRequest, IPaginated {
  attribute?: string;
  direction?: string;
}
export async function getAll({
  api,
  offset,
  limit,
  attribute,
  direction,
}: IGetAll) {
  let params = {
    ...getSorterParamsForApi({ attribute, direction }),
    offset,
    limit,
  };

  let response = (await api.get('bank_entities', {
    params,
  })) as AxiosResponse<{
    data: { data: IBankEntity[] };
    meta: PaginationMeta;
  }>;

  return response.data.data.data;
}
